// extracted by mini-css-extract-plugin
var _1 = "FormButtonAdd-moduleFormButtonAdd__YsG4w";
export { _1 as "FormButtonAdd" }
